<template>
  <md-progress-spinner
    md-mode="indeterminate"
    :md-diameter="diameter"
    :md-stroke="stroke"
  ></md-progress-spinner>
</template>

<script>
export default {
  props: {
    diameter: {
      type: Number,
    },
    stroke: {
      type: Number,
    },
  },
}
</script>
